export class AdmitAdRetargetingTracker
{
    static init() {
        window._retag = window._retag || [];
        return window._retag;
    }

    static registerPageView() {
        window._retag_data = {};
        window._retag.push({code: '9ce888632e'});
    }

    static indexPageView() {
        window._retag.push({code: '9ce8886333', level: 0});
    }

    static categoryPageView(category) {
        window.ad_category = category.id;
        window._retag.push({code: '9ce8886332', level: 1});
    }

    static productPageView(product) {
        window.ad_product = {
            id: product.id,
            vendor: product.vendor,
            price: product.price,
            url: window.location.origin + product.url,
            picture: window.location.origin + product.picture,
            name: product.name,
            category: product.category
        };
        window._retag.push({code: '9ce8886331', level: 2});
    }

    static basketPageView(basket) {
        window.ad_products = collectBasketItems(basket);
        window._retag.push({code: '9ce8886330', level: 3});
    }

    static orderPageView() {
        AdmitAdRetargetingTracker.registerPageView();
    }

    static orderThankyouPageView(order, basket) {
        window.ad_order = order.id;
        window.ad_amount = order.price;
        window.ad_products = collectBasketItems(basket);
        window._retag.push({code: '9ce888632f', level: 4});
    }
}

let collectBasketItems = (basket) => {
    const items = [];
    basket.forEach((basketItem) => {
        items.push({
            id: basketItem.id,
            number: basketItem.quantity
        });
    });
    return items;
};


// WEBPACK FOOTER //
// ./modules/tracker/admitad-retargeting.js